import supabase from "../supabase-client";

// A provider cancelled a service's CFDI and issued a replacement. The
// replacement goes on the SAME service (attach_replacement_invoice): the
// service and its payments point at the new CFDI, the old one stays in
// service_invoices. `replaces` is the UUID the XML says it substitutes
// (relación 04); without it the RPC only accepts a service whose CFDI SAT
// already reported cancelled. Throws the RPC's message on refusal.
export async function attachReplacementInvoice({ serviceId, cfdi, xmlFile, pdfFile, replaces = null }) {
  const { data, error } = await supabase.rpc("attach_replacement_invoice", {
    p_service: Number(serviceId),
    p_invoice: cfdi.uuid,
    p_invoice_id: cfdi.folio,
    p_total: cfdi.total,
    p_issuer_rfc: cfdi.emisorRfc,
    p_stamped_at: cfdi.fechaTimbrado || null,
    p_replaces: replaces,
    p_source: "replacement_upload",
  });
  if (error) throw new Error(error.message);

  // Same layout as every service invoice: <performed_at date>/<uuid>.xml|pdf.
  const base = String(data.performed_at).split("T")[0].replace(/-/g, "/") + "/" + cfdi.uuid;
  const uploads = [supabase.storage.from("incoming-invoices").upload(base + ".xml", xmlFile)];
  if (pdfFile) uploads.push(supabase.storage.from("incoming-invoices").upload(base + ".pdf", pdfFile));
  const failed = (await Promise.all(uploads)).filter((r) => r.error);
  if (failed.length) console.error(failed.map((r) => r.error));
  return { service: data, filesFailed: failed.length > 0 };
}

// The service whose CURRENT CFDI one of these UUIDs is, if any.
export async function serviceHoldingInvoice(uuids) {
  for (const uuid of uuids || []) {
    const { data } = await supabase.rpc("service_for_invoice", { p_uuid: uuid });
    const current = (data || []).find((r) => r.is_current);
    if (current) return { ...current, replaces: uuid };
  }
  return null;
}
